import "./Footer.scss";

import { Children, useCallback, useEffect, useState } from "react";

import { getFooterData } from "../../../services/miscRequestServices";
import { getCopyrightTitle } from "../../../services/pagesRequestServices";
import { Link } from "react-router-dom";

const Footer = () => {
  const [menuData, changeMenuData] = useState([]);
  const [copyrightText, changeCopyrightText] = useState(null);

  const getMenuData = useCallback(() => {
    return getFooterData().then(({ results }) => changeMenuData(results));
  }, []);

  const getCopyrightText = useCallback(() => {
    return getCopyrightTitle().then((res) => changeCopyrightText(res));
  }, []);

  useEffect(() => {
    getMenuData();
    getCopyrightText();
  }, [getMenuData, getCopyrightText]);

  return (
    <div className="footer_main-container">
      <div className="footer_main-links d-flex flex-wrap justify-content-center">
        {Children.toArray(
          menuData.map((item) => <Link to={item.url}>{item.title}</Link>)
        )}
      </div>
      <div className="footer_main-copyright-notice me-4">
        {copyrightText?.title}
      </div>
    </div>
  );
};

export default Footer;
